/* The hero playing a trainer's YouTube material — canvas „Ćwiczenia: YouTube w podglądzie",
 * 25 September 2026, variant D. The box is the hero's own (`TheatreHero.module.css` `.hero`), so
 * swapping one for the other changes ink and never geometry. Every surface drawn on the film is
 * theme-independent: the film is the same film in Flame and in Flame Dark. */

.stage {
  position: relative;
  flex: 1;
  min-height: var(--h-ex-theatre-hero);
  overflow: hidden;
  background: var(--player-stage);
  border-radius: var(--radius-sm);
}

.frame,
.frameUpright {
  position: absolute;
  inset: var(--space-0);
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

/* A Short: 9:16 standing in the middle, the stage showing either side. Never cropped. */
.frameUpright {
  left: 50%;
  width: auto;
  aspect-ratio: 9 / 16;
  transform: translateX(-50%);
}

/* ── The source chip ─────────────────────────────────────────────────────────────────────────── */

/* `pointer-events: none` over the frame, so the band never swallows a press meant for the player. */
.top {
  position: absolute;
  top: var(--space-0);
  right: var(--space-0);
  left: var(--space-0);
  display: flex;
  padding: var(--space-14px) var(--space-14px) var(--space-10);
  pointer-events: none;
  background: var(--scrim-ex-film-top);
}

.chip {
  display: inline-flex;
  gap: var(--space-2);
  align-items: center;
  min-width: 0;
  height: 32px;
  padding: var(--space-0) var(--space-3) var(--space-0) var(--space-5px);
  color: var(--text-on-photo);
  background: var(--wash-on-photo-badge);
  border-radius: var(--radius-8px);
}

.chipMark {
  display: grid;
  flex: none;
  place-items: center;
  width: 22px;
  height: 22px;
  background: var(--plate-on-photo);
  border-radius: var(--radius-6-5px);
}

.chipGlyph {
  display: block;
  width: 14px;
  height: 14px;
}

.chipLabel {
  min-width: 0;
  overflow: hidden;
  font-size: var(--fs-exercise);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chipHost {
  flex: none;
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-auto);
  color: var(--text-2-on-photo);
}

/* ── The owner's refusal ─────────────────────────────────────────────────────────────────────── */

.still {
  position: absolute;
  inset: var(--space-0);
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.refusal {
  position: absolute;
  inset: var(--space-0);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  color: var(--text-on-photo);
  text-align: center;
  background: var(--wash-on-photo-strong);
}

.refusalMark {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  background: var(--plate-on-photo);
  border-radius: var(--radius-10-5px);
}

.refusalGlyph {
  display: block;
  width: 24px;
  height: 24px;
}

.refusalTitle {
  margin: var(--space-0);
  font-size: var(--fs-mode);
  font-weight: var(--fw-extrabold);
  line-height: var(--lh-auto);
}

.refusalBody {
  max-width: 44ch;
  margin: var(--space-0);
  font-size: var(--fs-exercise);
  line-height: var(--lh-note);
  color: var(--text-on-scrim);
}

.out {
  display: inline-flex;
  gap: var(--space-6px);
  align-items: center;
  height: 32px;
  margin-top: var(--space-1);
  padding: var(--space-0) var(--space-3);
  font-size: var(--fs-note);
  font-weight: var(--fw-bold);
  line-height: var(--lh-auto);
  color: var(--text-on-plate);
  text-decoration: none;
  background: var(--plate-on-photo);
  border-radius: var(--radius-8px);
}

.out:focus-visible {
  outline: var(--border-focus) solid var(--text-on-photo);
  outline-offset: var(--space-2px);
}

.outGlyph {
  display: block;
  width: 14px;
  height: 14px;
}
